import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Filter = ({
  size,
  type,
  theme,
  className,
  dataTestId = "filter-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.0617 3.2594C3.14951 3.09942 3.31751 3 3.5 3H13.5C13.6825 3 13.8505 3.09942 13.9383 3.2594C14.0261 3.41937 14.0198 3.61448 13.9218 3.76844L10.5 9.1456V11C10.5 11.1894 10.393 11.3625 10.2236 11.4472L7.22361 12.9472C7.06861 13.0247 6.88454 13.0164 6.73713 12.9253C6.58973 12.8342 6.5 12.6733 6.5 12.5V9.1456L3.07817 3.76844C2.98019 3.61448 2.97388 3.41937 3.0617 3.2594ZM4.41084 4L7.42183 8.73156C7.47288 8.81179 7.5 8.90491 7.5 9V11.691L9.5 10.691V9C9.5 8.90491 9.52712 8.81179 9.57817 8.73156L12.5892 4H4.41084Z"
    />
  </SVGIcon>
);
